export function handleInput(e, kind, data, setData){
    //Deal with Input Text
    if(e.target){
        switch(e.target.name) {
            case "name":
                setData( data = { ...data,
                    name: e.target.value
                })
                return null
            default:
                break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/general/branchFormWrapper/handleInput.js